import constant from "../constants/layerConstant";

export const layerInitialState = {
  treeData: [],
};
export function layerReducer(state, action) {
  switch (action.type) {
    case constant.GET_TREE:
      return {
        ...state,
        treeData: [],
      };
    case constant.GET_TREE_SUCCESS:
      return {
        ...state,
        treeData: action.payload.data,
      };
    case constant.GET_TREE_FAIL:
      return {
        ...state,
        treeData: [],
      };

    default:
      return state;
  }
}

export default layerReducer;